import { render, staticRenderFns } from "./quotation-intro.vue?vue&type=template&id=8f7375f0"
import script from "./quotation-intro.vue?vue&type=script&lang=js"
export * from "./quotation-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7375f0')) {
      api.createRecord('8f7375f0', component.options)
    } else {
      api.reload('8f7375f0', component.options)
    }
    module.hot.accept("./quotation-intro.vue?vue&type=template&id=8f7375f0", function () {
      api.rerender('8f7375f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-intro.vue"
export default component.exports